import random from 'random'

export function getRandomInt(min, max) {
    const result = random.int(min, max);
    return result;
}